// const REPORT_BASE_URL = `https://v1reports.eregistrationukgov.in/Report`;
const REPORT_BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://v1reports.eregistrationukgov.in"
    : "https://localhost:44378";

const REPORT_BASE_URLDSC =
  process.env.NODE_ENV === "production"
    ? "https://vreports.eregistrationukgov.in"
    : "https://localhost:44378";

export { REPORT_BASE_URLDSC };

export default REPORT_BASE_URL;
